import { FornecedorDropDown } from "../../../../../common/domain/models/fornecedor_dropdown";
import { IGetFornecedoresDetalheDropDownUseCase } from "../../../presentation/useCases/read/get_fornecedores_detalhe_drop_down_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetFornecedoresDetalheDropDownUseCase
 */

export class GetFornecedoresDetalheDropDownUseCase implements IGetFornecedoresDetalheDropDownUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getFornecedoresDetalheDropDown(
  ): Promise<FornecedorDropDown[]> {
    return await this.repository.getFornecedoresDetalheDropDown();
  }
}
